import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useRef, useState } from 'react';
import '../../CSS/Global.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../SideBar';
import Header from '../Header';
import Select from 'react-select';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import ImageModalEquip from '../Modal/ImageModalProd';
import ImageModalDownloadable from '../Modal/ImageModalDownloadble';
import ImageModalGallery from '../Modal/ImageModalGallery';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { Eye, EyeOff, Trash2, X } from 'lucide-react';
import { decryptToken } from '../utils/getToken';
import { getDiscountValidationError } from './productPricingValidation';
import {
    resolveBrandName,
    matchCategoryOption,
    matchBrandOption,
    preserveSelectOption,
} from './productSelectUtils';
import ProductButtonOptions from "./ProductButtonOptions";
import Swal from 'sweetalert2';

import {
    DndContext,
    closestCenter
} from "@dnd-kit/core";

import {
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
    arrayMove
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}


const generateUniqueSKU = (() => {
    const usedSKUs = new Set();

    return () => {
        let sku;
        do {
            sku = 'SKU-' + Math.random().toString(36).substring(2, 10).toUpperCase();
        } while (usedSKUs.has(sku));
        usedSKUs.add(sku);
        return sku;
    };
})();


const generateMissingVariations = (existingVariations, selectedAttributes) => {
    if (!selectedAttributes?.length) return [];

    // Create list of arrays like [[red, blue], [S, M], [10kg,20kg]]
    const attrTermArrays = selectedAttributes.map(attr =>
        attr.selectedTermIds.map(termId => ({ attrId: attr.id, termId }))
    );

    // Cartesian product to create all expected combinations
    const cartesian = (arrays) =>
        arrays.reduce((acc, curr) =>
            acc.flatMap(a => curr.map(c => [...a, c]))
            , [[]]);

    const allCombos = cartesian(attrTermArrays);

    // Convert existing variations to key-set for comparison
    const existingKeys = new Set(
        existingVariations.map(v =>
            Object.entries(v.attributes)
                .sort((a, b) => a[0] - b[0])
                .map(([k, v]) => `${k}:${v}`)
                .join('|')
        )
    );

    const newVariations = [];

    allCombos.forEach(combo => {
        const comboMap = {};
        combo.forEach(item => {
            comboMap[item.attrId] = item.termId;
        });

        const key = Object.entries(comboMap)
            .sort((a, b) => a[0] - b[0])
            .map(([k, v]) => `${k}:${v}`)
            .join('|');

        if (!existingKeys.has(key)) {
            newVariations.push({
                id: `v_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`,
                attributes: comboMap,
                price: 0,
                salePrice: 0,
                title:'',
                sku: `SKU-${Math.random().toString(36).substr(2, 6).toUpperCase()}`,
                stock: 0
            });
        }
    });

    return newVariations;
};

function SortableKeyFeature({ feature, setFormData }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: feature.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <li
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className="oms-tag-item"
        >
            {feature.text}

            <X
                type="button"
                className="oms-tag-delete"
                onClick={() => {
                    setFormData(prev => ({
                        ...prev,
                        key_features: prev.key_features.filter(
                            f => f.id !== feature.id
                        )
                    }));
                }}
                size={14}
            />
        </li>
    );
}



const VariableProductEdit = () => {
    const { id } = useParams();
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const [keyFeatureInput, setKeyFeatureInput] = useState('');
    const [specInput, setSpecInput] = useState({ label: '', value: '' });
    const [formData, setFormData] = useState({
        image: [],
        gallery: [],
        title: '',
        product_type: { value: 'Variable Product', label: 'Variable Product' },
        category: null,
        status: null,
        stock: "Unlimited Stock",
        typeofsimple: "",
        categorytype: "",
        short_description: "",
        description: "",
        attribute: [],
        variation: [],
        user_id: user.main_id,
        user_name: user.full_name,
        delivery_days: "",
        key_features: [],
        specifications: [],
        category_id: "",
        categorytype_id: [],
        warranty: "Yes",
        warranty_from: "",
        warranty_note: "",
        brand_name: "",
        installation: "",
        installation_fee: "",
        brand_id: [],
        gst_type: "included",
        gst_percentage: "",
        hsn: "",
        add_to_cart: false,
        buy_now: false,
        inquiry: false,
    });
    const [availableSizes] = useState(["XS", "S", "M", "L", "XL", "XXL"]);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [variationsAccordion, setVariationsAccordion] = useState([]);
    const [showVariations, setShowVariations] = useState(false);
    const navigate = useNavigate();
    const [variationErrors, setVariationErrors] = useState({});
    const [categories, setCategories] = useState([]);
    const [brand, setBrand] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const url = API_BASE_URL
    console.log(formData)
    const [activeIndex, setActiveIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const token = decryptToken("accessToken") || ""
    const toggleAccordion = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    const updateVariation = (index, field, value) => {
        setVariations(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    const searchListStyles = {
        container: {
            maxHeight: '250px',
            overflowY: 'auto',
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '10px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        },
        item: {
            display: 'flex',
            alignItems: 'center',
            padding: '10px',
            borderBottom: '1px solid #eee',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
        },
        itemHover: {
            backgroundColor: '#f8f9fa',
        },
        image: {
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            marginRight: '15px',
        },
        info: {
            display: 'flex',
            flexDirection: 'row',
            gap: "5px",
            alignItems: "center"
        },
        studentName: {
            fontWeight: '600',
            fontSize: '14px',
            marginBottom: '2px',
        },
        studentID: {
            fontSize: '12px',
            color: '#666',
        },
    };

    const attributeOptions = [
        { value: 'size', label: 'Size' },
        { value: 'weight', label: 'Weight' },
        { value: 'length', label: 'Length' },
        { value: 'thickness', label: 'Thickness' },
        // Add more as needed
    ];

    const sizeOptions = [
        { value: 'S', label: 'S' },
        { value: 'M', label: 'M' },
        { value: 'L', label: 'L' },
        { value: 'XL', label: 'XL' },
        { value: 'XXL', label: 'XXL' },
    ];

    const WeightOptions = [
        { value: '30 kg', label: '30 kg' },
        { value: '50 kg', label: '50 kg' },

    ]

    const fetchCategories = async () => {
        try {
            const response = await fetch(`${url}/category/getdata/category/${user.main_id}`, {
                method: "GET",
                // credentials: "include"
            })
            const res = await response.json();
            const options = res.map(cat => ({
                value: cat.id,
                label: cat.category || cat.category || cat.category,
                id: cat.id
            }));
            setCategories(options);
        } catch (error) {
            console.error(error)
        }
    }

    const fetchBrand = async () => {
        try {
            const response = await fetch(`${url}/brand/getall`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();

            const options = res.data.map(cat => ({
                value: cat.id,
                label: cat.name || cat.name || "Unnamed Category",
                id: cat.id
            }));

            // Add the dummy "Select" option at the top
            // const withDummy = [{ value: "", label: "Select" }, ...options];

            setBrand(options);
        } catch (error) {
            console.error(error);
        }
    };

    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [showImageModalGallery, setShowImageModalGallery] = useState(false);
    const [imagesGallery, setImagesGallery] = useState([]);
    const [isUploadModalOpen, setUploadModalOpen] = useState(false);
    const [variations, setVariations] = useState([]);
    const [variationDetails, setVariationDetails] = useState({});
    const [selectedImageVar, setSelectedImageVar] = useState(null); // For main product image
    const [showModalVar, setShowModalVar] = useState(false);
    const [showModalVar1, setShowModalVar1] = useState(false);
    const [imagesVar, setImagesVar] = useState([]);
    const [variationImages, setVariationImages] = useState({}); // Track selected images for each variation
    const [currentVariationId, setCurrentVariationId] = useState(null);
    const [variationGalleryImages, setVariationGalleryImages] = useState({});
    const [selectedAttributes, setSelectedAttributes] = useState([]);
    const [accordionsState, setAccordionsState] = useState({});
    const [attribute, setAttribute] = useState([]);
    const [filteredAttribute, setFilteredAttribute] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [savedAttributeIds, setSavedAttributeIds] = useState([]);
    const [productSingle, setProductSingle] = useState({});
    const [productRaw, setProductRaw] = useState(null);
    const productHydratedRef = useRef(false);
    const handleOpenModalVar = (variationId) => {
        setCurrentVariationId(variationId); // Set the variation ID
        setShowModalVar(true); // Open the modal
    };

    const handleCloseModalVar = () => {
        setShowModalVar(false);
    };

    const handleImageView = async () => {
        const all = await axios.get(`${url}/api/images/${user.main_id}`);
        setImages((all.data).reverse());
    }
    const fetchImagesVar = async () => {
        const all = await axios.get(`${url}/api/images/${user.main_id}`);
        setImagesVar((all.data).reverse());
    }
    // const handleRemoveVariationImage = (variationId) => {
    //     setVariationImages((prevImages) => {
    //         const updatedImages = { ...prevImages };
    //         delete updatedImages[variationId];
    //         return updatedImages;
    //     });
    // };

    // const updateTypeofSimple = (key, isChecked) => {
    //     const currentTypes = formData.typeofsimple.split(',').filter(Boolean);
    //     let updatedTypes = isChecked
    //         ? [...new Set([...currentTypes, key])]
    //         : currentTypes.filter(type => type !== key);

    //     setFormData((prev) => ({
    //         ...prev,
    //         typeofsimple: updatedTypes.join(',')
    //     }));
    // };

    const updateTypeofCat = (key, isChecked) => {
        let updatedTypes = (formData.categorytype || "").split(',').filter(Boolean);


        if (key === 'Best Sellers' && isChecked) {
            // Add 'virtual', remove 'downloadable'
            updatedTypes = ['Best Sellers'];
        } else if (key === 'Trending' && isChecked) {
            // Add 'downloadable', remove 'virtual'
            updatedTypes = ['Trending'];
        } else {
            // Remove the key from selection
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            categorytype: updatedTypes.join(',')
        }));
    };

    const updateTypeofWar = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            // Only allow one selected at a time
            updatedTypes = [key];
        } else {
            // If unchecked, clear selection
            updatedTypes = [];
        }

        setFormData((prev) => ({
            ...prev,
            warranty: updatedTypes.join(','),
        }));
    };


    const updateTypeofWarfrom = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            // Only allow one selected at a time
            updatedTypes = [key];
        } else {
            // If unchecked, clear selection
            updatedTypes = [];
        }

        setFormData((prev) => ({
            ...prev,
            warranty_from: updatedTypes.join(','),
        }));
    };

    const updateTypeofInstall = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            updatedTypes = [key]; // allow only one selection
        } else {
            updatedTypes = []; // none selected if unchecked
        }

        setFormData((prev) => ({
            ...prev,
            installation: updatedTypes,
        }));
    };



    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];
    const [genrte, setGenerate] = useState(false)

    const categoryOptions = [
        { value: 'electronics', label: 'Electronics' },
        { value: 'fashion', label: 'Fashion' },
        { value: 'home', label: 'Home' },
        { value: 'books', label: 'Books' },
    ];

    const ProductOptions = [
        { value: 'Simple Product', label: 'Simple Product' },
        { value: 'Grouped Product', label: 'Grouped Product' },
        { value: 'External/Affiliate Product', label: 'External/Affiliate Product' },
        { value: 'Variable Product', label: 'Variable Product' },
    ];

    const StockOptions = [
        { value: 'In stock', label: 'In stock' },
        { value: 'Out of stock', label: 'Out of stock' },
        { value: 'Unlimited Stock', label: 'Unlimited Stock' },
    ];

    const handleChange1 = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,              // keeps {value: "Electronics", label: "Electronics", id: 5}
            category_id: selectedOption?.id || "" // 👈 stores actual id
        }));
    };

    const handleSelectChangeBrand = (selectedOption, { name }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,               // keep label+value for UI
            brand_id: selectedOption?.value || "", // keep value for backend
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        let hasError = false;
        let firstErrorIndex = -1;
        let firstErrorMessage = "";

        variations.forEach((variation, index) => {
            const details = variationDetails[variation.id] || {};
            const regularPrice = parseFloat(details.price || 0);
            const salePrice = parseFloat(details.salePrice || 0);
            const discountErr = getDiscountValidationError(details, regularPrice, {
                baseLabel: "regular price",
            });
            const variationLabel =
                Object.values(variation.attributes).join(" & ") || `Variation #${index + 1}`;

            if (discountErr) {
                hasError = true;
                if (firstErrorIndex === -1) {
                    firstErrorIndex = index;
                    firstErrorMessage = `${discountErr} (${variationLabel})`;
                }
            } else if (!isNaN(salePrice) && !isNaN(regularPrice) && salePrice > regularPrice) {
                hasError = true;
                if (firstErrorIndex === -1) {
                    firstErrorIndex = index;
                    firstErrorMessage = `Sale price cannot be greater than regular price. (${variationLabel})`;
                }
            }
        });

        if (hasError) {
            toast.error(firstErrorMessage);
            setActiveIndex(firstErrorIndex);
            setLoading(false);
            return;
        }

        // Submit data
        // console.log("✅ Submitting valid form data:", formData);
        try {
            const payload = {
                ...formData,
                warranty: Array.isArray(formData.warranty)
                    ? formData.warranty[0] || ""
                    : formData.warranty,

                warranty_from: Array.isArray(formData.warranty_from)
                    ? formData.warranty_from[0] || ""
                    : formData.warranty_from,

                installation: Array.isArray(formData.installation)
                    ? formData.installation[0] || ""
                    : formData.installation,
                image: typeof formData.image[0] === 'string'
                    ? formData.image[0]
                    : formData.image[0]?.url || "",
                product_type: formData.product_type?.value || "", // ✅ Convert to string
                status: formData.status?.value || "",
                stock: formData.stock?.value || "",
                categorytype: Array.isArray(formData.categorytype)
                    ? formData.categorytype.join(',')
                    : formData.categorytype,
                category: formData.category?.value || "",
                user_id: user.main_id,
                user_name: user.full_name,
                variation: variations,
                brand_name: resolveBrandName(formData.brand_name),
                // warranty_from: formData?.warranty_from || formData.warranty_from || "",
                // installation: formData.installation[0] || "",
                gst_type: formData.gst_type,
                gst_percentage: formData.gst_type === "excluded" ? formData.gst_percentage : null,
            };

            const response = await fetch(`${url}/variable-product/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });
            const res = await response.json();
            if (response.ok) {
                navigate("/products")
                toast.success("Product Updated successfully", {
                    position: "top-center",
                    autoClose: 2000
                });
                console.log("Product submitted successfully");
            } else {
                toast.warning(res.message)
                console.error("Failed to submit product");
                setLoading(false);
            }

        } catch (error) {
            console.error("Submission error:", error);
        } finally {
            setLoading(false);
        }
    };

    const [activeVariationId, setActiveVariationId] = useState(null);
    const [activePreviewImage, setActivePreviewImage] = useState("");



    useEffect(() => {
        if (!id) return;
        productHydratedRef.current = false;
        setProductRaw(null);

        const fetchSingleProduct = async () => {
            try {
                const response = await axios.get(`${url}/grouped-product/single/${id}`);
                setProductRaw(response.data);
            } catch (error) {
                console.error("Error fetching product:", error);
                toast.error("Failed to fetch product data");
            }
        };

        fetchSingleProduct();
    }, [id]);

    useEffect(() => {
        if (!productRaw) return;

        const safeParse = (val) => {
            try {
                return typeof val === 'string' ? JSON.parse(val) : val || [];
            } catch (err) {
                return [];
            }
        };

        const matchedCategory = matchCategoryOption(categories, productRaw);
        const matchedBrand = matchBrandOption(brand, productRaw);

        if (!productHydratedRef.current) {
            productHydratedRef.current = true;

            setFormData({
                ...productRaw,
                product_type: { label: productRaw.product_type, value: productRaw.product_type },
                category: matchedCategory,
                brand_name: matchedBrand,
                status: { label: productRaw.status, value: productRaw.status },
                stock: { label: productRaw.stock, value: productRaw.stock },
                image: productRaw.image ? [productRaw.image] : [],
                gallery: safeParse(productRaw.gallery),
                attribute: safeParse(productRaw.attribute),
                variation: safeParse(productRaw.variation),
                key_features: safeParse(productRaw.key_features).map(f => ({
                    id: f?.id || crypto.randomUUID(),
                    text: f?.text || f
                })),
                specifications: safeParse(productRaw.specifications).map(spec => ({
                    ...spec,
                    id: spec.id || crypto.randomUUID()
                })),
                brand_id: safeParse(productRaw.brand_id)
            });

            const parsedVariations = safeParse(productRaw.variation);

                setVariations(parsedVariations);
                // 🟢 Auto-select attributes based on variations
                if (Array.isArray(parsedVariations) && parsedVariations.length > 0) {
                    const attrMap = {};

                    // Collect attribute → termIds mapping from variations
                    parsedVariations.forEach(v => {
                        Object.entries(v.attributes || {}).forEach(([attrId, termId]) => {
                            if (!attrMap[attrId]) attrMap[attrId] = new Set();
                            attrMap[attrId].add(Number(termId));
                        });
                    });

                    // Build selectedAttributes structure for UI
                    const rebuiltSelectedAttributes = Object.entries(attrMap).map(([attrId, termSet]) => {
                        const attr = attribute.find(a => a.id === Number(attrId));
                        if (!attr) return null;

                        // Filter only existing terms
                        const selectedTerms = attr.associatedTerms.filter(t => termSet.has(t.id));

                        return {
                            ...attr,
                            selectedTerms
                        };
                    }).filter(Boolean);

                    setSelectedAttributes(rebuiltSelectedAttributes);

                    // Update formData.attribute with only IDs
                    setFormData(prev => ({
                        ...prev,
                        attribute: rebuiltSelectedAttributes.map(a => ({
                            id: a.id,
                            selectedTermIds: a.selectedTerms.map(t => t.id)
                        }))
                    }));
                }

                console.log(parsedVariations)
                const initialVariationDetails = {};
                const initialVariationImages = {};
                const initialGalleryImages = {};
                let defaultPreviewImage = "";

                parsedVariations.forEach((variation, index) => {
                    initialVariationDetails[variation.id] = {
                        price: variation.price,
                        discount_type: variation.discount_type,
                        discount_price: variation.discount_price,
                        discount_percentage: variation.discount_percentage,
                        salePrice: variation.salePrice,
                        stock: variation.stock,
                        sku: variation.sku,
                        title:variation.title,
                        description: variation.description
                    };

                    if (variation.imageUrl) {
                        initialVariationImages[variation.id] = { url: variation.imageUrl };
                    }

                    if (variation.galleryImages?.length) {
                        initialGalleryImages[variation.id] = variation.galleryImages.map(url => ({ url }));
                        // Set first variation with gallery as default preview
                        if (index === 0 && variation.galleryImages.length > 0) {
                            setActivePreviewImage(variation.galleryImages[0]);
                            setActiveVariationId(variation.id);
                        }
                    }
                });

            setProductSingle({
                ...productRaw,
                product_type: productRaw.product_type,
                category: matchedCategory,
                brand_name: matchedBrand,
                status: { label: productRaw.status, value: productRaw.status },
                stock: { label: productRaw.stock, value: productRaw.stock },
                image: productRaw.image ? [productRaw.image] : [],
                gallery: safeParse(productRaw.gallery),
                attribute: safeParse(productRaw.attribute),
                variation: safeParse(productRaw.variation),
                key_features: safeParse(productRaw.key_features),
                specifications: safeParse(productRaw.specifications),
                brand_id: safeParse(productRaw.brand_id)
            });
            setVariationDetails(initialVariationDetails);
            setVariationImages(initialVariationImages);
            setVariationGalleryImages(initialGalleryImages);
            return;
        }

        setFormData((prev) => ({
            ...prev,
            category: preserveSelectOption(prev.category, matchedCategory),
            brand_name: preserveSelectOption(prev.brand_name, matchedBrand),
            category_id: prev.category_id || productRaw.category_id || "",
        }));
    }, [productRaw, categories, brand]);


    const handleNavigate = (url) => {
        navigate(url)
    };


    const fetchDataAttribute = async () => {
        try {
            const response = await fetch(`${url}/attribute/getdata/${user.main_id}`)
            const res = await response.json();

            setAttribute(res);
        } catch (error) {
            console.error(error);
        }
    }

    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        // console.log(query);
        if (query === '') {
            // If search query is empty, show all attributes
            setFilteredAttribute(attribute);
        } else {
            // If there is a search query, filter based on it
            const filtered = attribute.filter((attr) =>
                attr.name.toLowerCase().includes(query.toLowerCase())
            );
            setFilteredAttribute(filtered);
        }
    };
    const handleAttributeClick = (attribute) => {
        // Add the selected attribute to the selectedAttributes array
        setSelectedAttributes((prev) => [
            ...prev,
            { ...attribute, selectedTerms: [] },
        ]);
        setSearchQuery('');
        setFilteredAttribute([]);
        setAccordionsState((prevState) => ({
            ...prevState,
            [attribute.name]: true, // Open this accordion initially
        }));
    };

    const handleSelectAll = (e, attribute) => {
        e.preventDefault(); // ⛔ Prevent page reload
        const updatedAttributes = selectedAttributes.map((attr) =>
            attr.id === attribute.id
                ? { ...attr, selectedTerms: [...attr.associatedTerms] }
                : attr
        );
        setFormData({
            ...formData,
            attribute: updatedAttributes
        });
        setSelectedAttributes(updatedAttributes);
    };


    const handleDeselectAll = (e, attribute) => {
        e.preventDefault();
        const updatedAttributes = selectedAttributes.map((attr) =>
            attr.id === attribute.id
                ? { ...attr, selectedTerms: [] }
                : attr
        );
        setFormData({
            ...formData,
            attribute: updatedAttributes
        })
        setSelectedAttributes(updatedAttributes);
    };

    const toggleAttributeAccordion = (attrName) => {
        setAccordionsState((prev) => ({
            ...prev,
            [attrName]: !prev[attrName],
        }));
    };


    const handleTermClick = (attribute, term) => {
        const updatedAttributes = selectedAttributes.map((attr) => {
            if (attr.id === attribute.id) {
                const isSelected = attr.selectedTerms.includes(term);
                const updatedTerms = isSelected
                    ? attr.selectedTerms.filter((t) => t.id !== term.id)
                    : [...attr.selectedTerms, term];
                return { ...attr, selectedTerms: updatedTerms };
            }
            return attr;
        });
        setFormData({
            ...formData,
            attribute: updatedAttributes
        })
        setSelectedAttributes(updatedAttributes);
    };


    const handleVariationImageSelect = (variationId, image) => {
        if (!image?.url) {
            console.error("Invalid image:", image);
            return;
        }

        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === variationId
                    ? { ...variation, imageUrl: image.url }
                    : variation
            )
        );

        setFormData((prevEquipment) => ({
            ...prevEquipment,
            variation: prevEquipment.variation.map((variation) =>
                variation.id === variationId
                    ? { ...variation, imageUrl: image.url }
                    : variation
            ),
        }));

        setVariationImages((prevImages) => ({
            ...prevImages,
            [variationId]: image, // Store the selected image per variation
        }));

        setShowModalVar(false);
    };



    const handleVariationGallerySelect = (variationId, images) => {
        if (!Array.isArray(images) || images.length === 0) {
            console.error("Invalid images:", images);
            return;
        }

        // Ensure images are in { url: "" } format
        const newGallery = images.map(img => ({ url: img.url }));

        // Update preview state
        setVariationGalleryImages((prevImages) => ({
            ...prevImages,
            [variationId]: [...(prevImages[variationId] || []), ...newGallery],
        }));

        // Update variations state
        setVariations((prev) =>
            prev.map((variation) =>
                variation.id === variationId
                    ? {
                        ...variation,
                        galleryImages: [...(variation.galleryImages || []), ...newGallery.map(i => i.url)],
                    }
                    : variation
            )
        );

        // Update formData.variation for submit
        setFormData((prev) => ({
            ...prev,
            variation: prev.variation.map((variation) =>
                variation.id === variationId
                    ? {
                        ...variation,
                        galleryImages: [...(variation.galleryImages || []), ...newGallery.map(i => i.url)],
                    }
                    : variation
            )
        }));

        setShowModalVar1(false);
    };



    const handleRemoveGalleryImage = (variationId, index) => {
        setVariationGalleryImages((prevImages) => {
            const updated = [...(prevImages[variationId] || [])];
            updated.splice(index, 1);
            return { ...prevImages, [variationId]: updated };
        });

        setVariations((prev) =>
            prev.map((variation) =>
                variation.id === variationId
                    ? {
                        ...variation,
                        galleryImages: (variation.galleryImages || []).filter((_, i) => i !== index),
                    }
                    : variation
            )
        );

        setFormData((prev) => ({
            ...prev,
            variation: prev.variation.map((variation) =>
                variation.id === variationId
                    ? {
                        ...variation,
                        galleryImages: (variation.galleryImages || []).filter((_, i) => i !== index),
                    }
                    : variation
            )
        }));
    };


    const getVariationLabel = (variation) => {
        const parts = [];

        for (let [attrId, termId] of Object.entries(variation.attributes)) {
            const attr = selectedAttributes.find(a => a.id === Number(attrId));
            if (!attr) continue;

            const term = attr.associatedTerms.find(t => t.id === Number(termId));
            if (!term) continue;

            parts.push(`${attr.name}: ${term.name}`);
        }
        return parts.join(" | ");
    };


    // Handle removing variation images
    const handleRemoveVariationImage = (variationId) => {
        setVariationImages((prevImages) => {
            const updatedImages = { ...prevImages };
            delete updatedImages[variationId];
            return updatedImages;
        });
    };
    // Utility function to generate random 6-character ID
    const generateRandomId = () => {
        return Math.random().toString(36).substr(2, 6);
    };



    // const handleVariationDetailChange = (id, field, value) => {
    //     // Ensure sale price is not greater than regular price
    //     const updatedDetails = {
    //         ...variationDetails[id],
    //         [field]: value
    //     };

    //     const regularPrice = parseFloat(field === "price" ? value : updatedDetails.price);
    //     const salePrice = parseFloat(field === "salePrice" ? value : updatedDetails.salePrice);

    //     const newErrors = { ...variationErrors };

    //     if (!isNaN(salePrice) && !isNaN(regularPrice) && salePrice > regularPrice) {
    //         newErrors[id] = "Sale price cannot be higher than regular price.";
    //     } else {
    //         delete newErrors[id];
    //     }

    //     setVariationErrors(newErrors);

    //     // Update the main formData
    //     setFormData((prevEquipment) => ({
    //         ...prevEquipment,
    //         variation: prevEquipment.variation.map(variation => {
    //             if (variation.id === id) {
    //                 return {
    //                     ...variation,
    //                     price: field === 'price' ? value : variation.price,
    //                     salePrice: field === 'salePrice' ? value : variation.salePrice,
    //                     sku: field === 'sku' ? value : variation.sku,
    //                     stock: field === 'stock' ? value : variation.stock
    //                 };
    //             }
    //             return variation;
    //         })
    //     }));

    //     // Update the local variations state
    //     setVariations((prevVariations) =>
    //         prevVariations.map((variation) =>
    //             variation.id === id
    //                 ? { ...variation, [field]: value }
    //                 : variation
    //         )
    //     );

    //     // Update variation details state
    //     setVariationDetails((prevState) => ({
    //         ...prevState,
    //         [id]: updatedDetails
    //     }));
    // };


    const handleVariationDetailChange = (id, field, value) => {

        const updatedDetails = {
            ...variationDetails[id],
            [field]: value
        };

        let regularPrice = parseFloat(field === "price" ? value : updatedDetails.price) || 0;
        let salePrice = parseFloat(updatedDetails.salePrice) || 0;

        const discountType = updatedDetails.discount_type || "price";
        const discountPrice = parseFloat(updatedDetails.discount_price) || 0;
        const discountPercentage = parseFloat(updatedDetails.discount_percentage) || 0;

        if (field === "discount_type") {
            if (value === "percentage") {
                updatedDetails.discount_price = 0;
            }
            if (value === "price") {
                updatedDetails.discount_percentage = 0;
            }
        }

        // 🔹 Auto calculate sale price
        if (regularPrice > 0) {

            if (discountType === "price") {
                salePrice = regularPrice - discountPrice;
            }

            if (discountType === "percentage") {
                salePrice = regularPrice - (regularPrice * discountPercentage) / 100;
            }

            if (salePrice < 0) salePrice = 0;

            updatedDetails.salePrice = salePrice.toFixed(2);
        }

        // Update main formData
        setFormData((prevEquipment) => ({
            ...prevEquipment,
            variation: prevEquipment.variation.map((variation) => {
                if (variation.id === id) {
                    return {
                        ...variation,
                        price: updatedDetails.price || variation.price,
                        title:updatedDetails.title ||variation.title,
                        salePrice: updatedDetails.salePrice || variation.salePrice,
                        sku: updatedDetails.sku || variation.sku,
                        stock: updatedDetails.stock || variation.stock,
                        discount_type: updatedDetails.discount_type,
                        discount_price: updatedDetails.discount_price,
                        discount_percentage: updatedDetails.discount_percentage
                    };
                }
                return variation;
            })
        }));


        // Update variations state
        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === id
                    ? { ...variation, ...updatedDetails }
                    : variation
            )
        );


        // Update variation details state
        setVariationDetails((prevState) => ({
            ...prevState,
            [id]: updatedDetails
        }));
    };

    const cartesianProduct = (arrays) => {
        return arrays.reduce((acc, curr) => {
            return acc.flatMap(a => curr.map(c => [...a, c]));
        }, [[]]);
    };

    // const handleGenerateVariations = (e) => {
    //     e.preventDefault(); // ⛔ Prevent page reload

    //     const termArrays = selectedAttributes.map(attr =>
    //         attr.selectedTerms.map(term => ({ attrId: attr.id, termId: term.id }))
    //     );

    //     const combinations = cartesianProduct(termArrays);

    //     const newVariations = combinations.map((combo, idx) => ({
    //         id: `v${idx}${Date.now()}`,
    //         attributes: Object.fromEntries(combo.map(item => [item.attrId, item.termId])),
    //         price: 0,
    //         salePrice: 0,
    //         sku: `SKU-${Math.random().toString(36).substr(2, 8).toUpperCase()}`,
    //         stock: 0
    //     }));

    //     // setFormData((prev) => ({
    //     //     ...prev,
    //     //     variation: newVariations
    //     // }));
    //     setVariations(newVariations);
    // };



    // const handleRemoveVariation = (id) => {
    //     setVariations(variations.filter(variation => variation.id !== id));
    // };

    const handleGenerateVariations = (e) => {
        e.preventDefault();

        const selected = selectedAttributes.map(a => ({
            id: a.id,
            selectedTermIds: a.selectedTerms.map(t => t.id)
        }));

        const missing = generateMissingVariations(variations, selected);

        if (missing.length === 0) {
            toast.info("No new variations to generate 😎");
            return;
        }

        setVariations(prev => [...prev, ...missing]);

        setFormData(prev => ({
            ...prev,
            variation: [...prev.variation, ...missing]
        }));
    };

    const handleRemoveVariation = (id) => {
        // 1️⃣ Remove the variation from the list
        const updatedVariations = variations.filter(v => v.id !== id);

        // 2️⃣ Update variation state
        setVariations(updatedVariations);
        setFormData(prev => ({
            ...prev,
            variation: prev.variation.filter(v => v.id !== id)
        }));

        // 3️⃣ Build attribute → term mapping from remaining variations
        const attrTermMap = {};
        updatedVariations.forEach(v => {
            if (v.attributes) {
                Object.entries(v.attributes).forEach(([attrId, termId]) => {
                    if (!attrTermMap[attrId]) attrTermMap[attrId] = new Set();
                    attrTermMap[attrId].add(Number(termId)); // ensure numeric
                });
            }
        });

        // 4️⃣ Rebuild attributes in correct structure
        const rebuiltAttributes = Object.entries(attrTermMap).map(([attrId, termSet]) => ({
            id: Number(attrId),
            selectedTermIds: Array.from(termSet)
        }));

        console.log("🧩 rebuiltAttributes:", rebuiltAttributes);

        // 5️⃣ Update formData with rebuilt attribute list
        setFormData(prev => ({
            ...prev,
            attribute: rebuiltAttributes
        }));
    };











    const handleDeleteAttribute = (attributeId) => {
        // Filter out the attribute with the given id
        const updatedAttributes = selectedAttributes.filter((attribute) => attribute.id !== attributeId);

        // Update the state with the filtered attributes
        setSelectedAttributes(updatedAttributes);
        setFormData({
            ...formData,
            attribute: updatedAttributes
        })

        // Optionally, if you're saving the changes to the backend, you can also call an API to delete the attribute here
        // await axios.delete(`${url}/api/attributes/${attributeId}`);
    };


    const handleSaveAttributes = (e, attribute) => {
        e.preventDefault();

        // Save only IDs
        const updatedAttributes = selectedAttributes.map(attr => ({
            id: attr.id,
            selectedTermIds: attr.selectedTerms.map(term => term.id)
        }));

        // Update attributes in formData
        setFormData(prev => {
            // Generate variations immediately after saving attributes
            const newVariations = generateVariations(updatedAttributes);

            return {
                ...prev,
                attribute: updatedAttributes,
                variation: newVariations
            };
        });

        setSavedAttributeIds(prev => [...prev, attribute.id]);
    };


    const generateVariations = (attributes) => {
        if (!attributes || attributes.length === 0) return [];

        // Start with an array with a single empty variation
        let result = [{}];

        attributes.forEach(attr => {
            const { id: attrId, selectedTermIds } = attr;

            const temp = [];
            result.forEach(variation => {
                selectedTermIds.forEach(termId => {
                    temp.push({
                        ...variation,
                        attributes: {
                            ...variation.attributes,
                            [attrId]: termId
                        }
                    });
                });
            });

            result = temp;
        });

        return result;
    };

    useEffect(() => {
        setVariationGalleryImages(prev => {
            const updated = { ...prev };
            delete updated.null;
            return updated;
        });
    }, []);

    const handleCopy = async () => {
        try {
            const confirm = await Swal.fire({
                title: 'Copy Product ?',
                text: `Duplicate "${productSingle.title}" ?`,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes, Copy",
            });

            if (!confirm.isConfirmed) return;

            const res = await axios.post(`${url}/grouped-product/copy-product/${productSingle.product_id}`,
                { user_id: user.main_id },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }

            )
            toast.success("Product copied!");
            navigate(`/variableedit-product/${res.data.newProduct.product_id}`);

        } catch (error) {
            toast.error("Copy failed")
        }
    }


    useEffect(() => {
        fetchDataAttribute();
        handleImageView();
        fetchImagesVar();
        fetchCategories();
        fetchBrand();
    }, [])


    return (
        <>

            <div >
                <div className="oms-header">
                    <h1 className="dashboard-title">Variable Product</h1>
                    <div className='flex gap-2  items-center'>
                        <button className="omsnewbutton-copy" onClick={handleCopy}>Copy</button>

                        {
                            loading ? <button className="oms-add-btn">
                                Updating...
                            </button> : <button onClick={handleSubmit} className="oms-add-btn">
                                Update
                            </button>
                        }

                        <div style={{ marginLeft: "10px", marginRight: "10px" }} className="lsuv-three-dots"
                            onClick={() => setShowDropdown(!showDropdown)} ref={dropdownRef}
                        >
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                            {showDropdown && (
                                <div className="lsuv-dropdown-menu">
                                    <div className="lsuv-dropdown-item" onClick={() => navigate("/simple-product")}>
                                        Simple Product
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={() => navigate("/grouped-product")}>
                                        Grouped Product
                                    </div>
                                    {/* <div className="lsuv-dropdown-item" onClick={() => navigate("/external-affiliate-product")}>
                                        Affiliate Product
                                    </div> */}
                                    <div className="lsuv-dropdown-item" onClick={() => navigate("//variable-product")}>
                                        Variable Product
                                    </div>


                                </div>
                            )}
                        </div>
                    </div>
                    {/* <div className="property-dropdown-wrapper">
                                            <button className="oms-add-btn" onClick={() => setIsOpen(!isOpen)}>
                                                Add Products
                                            </button>
                                            {isOpen && (
                                                <ul className="property-dropdown-menu">
                                                    <li onClick={() => handleNavigate('/simple-product')}>
                                                        Simple Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/grouped-product')}>
                                                        Grouped Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/grouped-product')}>
                                                        Grouped Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/external-affiliate-product')}>
                                                        Affiliate Product
                                                    </li> 
                                                    <li onClick={() => handleNavigate('/variable-product')}>
                                                        Variable Product
                                                    </li>
                                                </ul>
                                            )}
                                        </div> */}
                </div>
                <form className="oms-modal-form property-form"
                    // className="oms-modal-form"
                    onSubmit={handleSubmit}
                >


                    <div className='oms-givepaddingfrom'>
                        {/* <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Product Type
                            </label>
                            <Select
                                options={ProductOptions}
                                placeholder="Select Product Type"
                                name="product_type"
                                value={formData.product_type}
                                isDisabled
                            />
                        </div> */}
                        {/* Image Upload */}
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Name
                            </label>
                            <input
                                type="text"
                                id="title"
                                placeholder="Enter title"
                                value={formData.title}
                                onChange={handleChange1}
                            />
                        </div>


                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Short  Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.short_description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, short_description: value }))
                                }
                                placeholder="Enter Short Description"
                            />
                        </div>


                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, description: value }))
                                }
                                style={{ backgroundColor: "#fefffc" }}
                                placeholder="Enter Description"
                            />
                        </div>

                        {/* Product Image Upload */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Image</label>

                            {/* Button to open image modal */}
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModal(true)}
                            >
                                Choose Image
                            </button>


                            {/* Preview selected image */}
                            {formData.image.length > 0 && (
                                <div className="selected-image-preview">
                                    <img
                                        src={formData?.image ? `${url}${formData?.image}` : formData?.image}
                                        alt="Selected"
                                    />
                                    <p
                                        className='delete-btnomsprod'
                                        onClick={() => setFormData((prev) => ({ ...prev, image: [] }))}

                                    >
                                        <i class="fa-solid fa-xmark"></i>
                                    </p>
                                </div>
                            )}
                        </div>

                        <ImageModalEquip
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            onImageSelect={(img) =>
                                setFormData((prev) => ({ ...prev, image: [{ url: img.url }] }))
                            }

                            multiple={false}
                            setImages={setImages}
                        />

                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Gallery</label>
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModalGallery(true)}
                            >
                                Add Gallery Images
                            </button>

                            {/* Preview selected gallery images */}
                            <div className="gallery-preview">
                                {formData.gallery.map((img, index) => (
                                    <div key={index} style={{ display: 'inline-block', marginRight: 10, position: 'relative' }}>
                                        <img
                                            src={img?.url ? `${url}${img.url}` : img}
                                            alt="gallery"
                                            className='gallery-preview-image'
                                        // style={{ width: "80px", height: "80px", objectFit: "cover", border: "1px solid #ccc" }}
                                        />
                                        <p
                                            type="button"
                                            className='delete-btnomsprod'
                                            onClick={() => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    gallery: prev.gallery.filter((_, i) => i !== index)
                                                }));
                                            }}

                                        >
                                            <i class="fa-solid fa-xmark"></i>
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <ImageModalGallery
                            show={showImageModalGallery}
                            handleClose={() => setShowImageModalGallery(false)}
                            images={images}
                            multiple={true} // ⬅️ set to true for gallery
                            setImages={setImages}
                            onImageSelect={(imgs) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    gallery: Array.isArray(imgs) ? [...prev.gallery, ...imgs] : [...prev.gallery, imgs]
                                }));
                            }}
                        />

                        <div className="oms-form-group">
                            <label className="oms-form-label">Select Attributes</label>
                            <input type="text"
                                value={searchQuery}
                                onChange={handleSearch}
                                placeholder="Enter attribute (e.g., Color, Size)"
                            />
                            {filteredAttribute.length > 0 && (
                                <div style={searchListStyles.container}>
                                    {filteredAttribute.map((attr) => (
                                        <div
                                            key={attr.id}
                                            style={searchListStyles.item}
                                            onClick={() => handleAttributeClick(attr)}
                                        >
                                            <span style={searchListStyles.studentName}>{attr.name}</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {selectedAttributes.map((attribute) => (
                                <div key={attribute.id} className="accordion mt-3 oms-attr-accordion">
                                    <div className="accordianinside oms-attr-accordion-inner" >
                                        <h5 className="attributenamedisplay oms-attr-title">{attribute.name}</h5>
                                        <div className="attributecloseexpand oms-attr-controls">
                                            <span
                                                className="oms-attr-expand-btn toggle-icon-btn"
                                                onClick={() => toggleAttributeAccordion(attribute.name)}
                                            >
                                                {accordionsState[attribute.name] ? <EyeOff size={22} /> : <Eye size={22} />}
                                            </span>
                                            <span
                                                className="oms-attr-delete-btn"
                                                onClick={() => handleDeleteAttribute(attribute.id)}
                                            >
                                                <Trash2 size={22} />
                                            </span>
                                        </div>
                                    </div>

                                    {accordionsState[attribute.name] && (
                                        <div className="valuewatch  oms-attr-value-box">
                                            <p>Value(s):</p>
                                            <div className="term-selection oms-attr-term-list">
                                                {attribute.associatedTerms.map((term) => (
                                                    <span
                                                        key={term.id}
                                                        className={`term-item oms-attr-term-item ${attribute.selectedTerms.includes(term)
                                                            ? 'selected'
                                                            : ''
                                                            }`}
                                                        onClick={() => handleTermClick(attribute, term)}
                                                    >
                                                        {term.name}
                                                    </span>
                                                ))}
                                            </div>
                                            <div className="threebuttontogether mt-3 oms-attr-actions">
                                                {attribute.associatedTerms.length > 0 && (
                                                    <>
                                                        {attribute.selectedTerms.length < attribute.associatedTerms.length ? (
                                                            <button
                                                                type="button"
                                                                className="me-2 oms-attr-btn-selectall"
                                                                onClick={(e) => handleSelectAll(e, attribute)}
                                                            >
                                                                Select all
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="me-2 oms-attr-btn-deselectall"
                                                                onClick={(e) => handleDeselectAll(e, attribute)}
                                                            >
                                                                Select none
                                                            </button>
                                                        )}
                                                    </>
                                                )}

                                                <button
                                                    type="button"
                                                    className="oms-attr-btn-save"
                                                    onClick={(e) => handleSaveAttributes(e, attribute)}
                                                >
                                                    Save attributes
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>


                        <div className="variation-wrapper oms-attr-variation-wrapper">
                            {/* Generate Variations Button */}
                            {selectedAttributes.length > 0 && selectedAttributes.every(attr => attr.selectedTerms.length > 0) && (
                                <button
                                    type='button'
                                    className="btn-generate oms-attr-generate-btn"
                                    onClick={(e) => handleGenerateVariations(e)}
                                >
                                    Generate Variations
                                </button>
                            )}



                            {/* Variations Display */}
                            {variations.length > 0 && (
                                <div className="accordion-list">
                                    {variations.map((variation, index) => (
                                        <div className="accordion-item" key={variation.id}>
                                            <div
                                                className="accordion-header"
                                                onClick={() => toggleAccordion(index)}
                                            >
                                                {/* <div className="accordion-title">
                                                    <strong>#{variation.id}</strong> - {Object.values(variation.attributes).join(' & ')}
                                                </div> */}
                                                <div className="accordion-title">
                                                    <strong>#{variation.id}</strong> - {getVariationLabel(variation)}
                                                </div>

                                                <span className="remove-btn" onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleRemoveVariation(variation.id);
                                                }}>Remove</span>
                                            </div>

                                            {activeIndex === index && (
                                                <div className="accordion-body">
                                                    {/* Product Image */}
                                                    <div className="form-group">
                                                            <label>Title:</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Title"
                                                                value={variationDetails[variation.id]?.title || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'title', e.target.value)}
                                                                
                                                            />
                                                        </div>
                                                    <div className="form-group">
                                                        <label>Product Image</label>
                                                        {!variationImages[variation.id] ? (
                                                            <input
                                                                type="text"
                                                                readOnly
                                                                placeholder="Choose image"
                                                                onClick={() => handleOpenModalVar(variation.id)}
                                                            />
                                                        ) : (
                                                            <div className="image-preview">
                                                                <img
                                                                    src={`${url}${variationImages[variation.id]?.url}`}
                                                                    alt="Selected"
                                                                    width={100}
                                                                    height={100}
                                                                    onClick={() => handleOpenModalVar(variation.id)}
                                                                    style={{ border: '2px solid #007bff', borderRadius: '5px' }}
                                                                />
                                                                <p className="remove-link" onClick={() => handleRemoveVariationImage(variation.id)}>
                                                                    Remove product image
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Product Gallery */}
                                                    <div className="form-group">
                                                        <label>Product Gallery</label>
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            placeholder="Choose gallery"
                                                            // onClick={() => setShowModalVar1(true)}
                                                            onClick={() => {
                                                                setCurrentVariationId(variation.id); // ✅ set correct ID
                                                                setShowModalVar1(true);
                                                            }}

                                                        // onClick={() => handleOpenModalVar1(variation.id)}
                                                        />
                                                        <div className="gallery-preview">
                                                            {Array.isArray(variationGalleryImages[variation.id]) && variationGalleryImages[variation.id].map((img, idx) => (
                                                                <div key={idx} className="gallery-img">
                                                                    <img
                                                                        src={`${url}${img.url}`}
                                                                        alt="Gallery"
                                                                        width={80}
                                                                        height={80}
                                                                    // onClick={() => handleOpenModalVar1(variation.id)}
                                                                    />
                                                                    <p
                                                                        type='button'
                                                                        className="delete-btnomsprod"
                                                                        onClick={() => handleRemoveGalleryImage(variation.id, idx)}
                                                                    >
                                                                        <i className="fa-solid fa-xmark"></i>
                                                                    </p>
                                                                </div>
                                                            ))}

                                                        </div>
                                                    </div>

                                                    {/* Price, Sale Price, Stock */}
                                                    <div className="form-row">
                                                        <div className="form-group">
                                                            <label>Regular Price:</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Price"
                                                                value={variationDetails[variation.id]?.price || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'price', e.target.value)}
                                                                onWheel={(e) => e.target.blur()}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label>Discount Type</label>

                                                            <div className="oms-checkbox-group">

                                                                <div className="oms-checkbox-item">
                                                                    <input
                                                                        type="radio"
                                                                        name={`discount_type_${variation.id}`}
                                                                        checked={(variationDetails[variation.id]?.discount_type || "price") === "price"}
                                                                        onChange={() =>
                                                                            handleVariationDetailChange(variation.id, "discount_type", "price")
                                                                        }
                                                                    />
                                                                    <label>Price</label>
                                                                </div>

                                                                <div className="oms-checkbox-item">
                                                                    <input
                                                                        type="radio"
                                                                        name={`discount_type_${variation.id}`}
                                                                        checked={variationDetails[variation.id]?.discount_type === "percentage"}
                                                                        onChange={() =>
                                                                            handleVariationDetailChange(variation.id, "discount_type", "percentage")
                                                                        }
                                                                    />
                                                                    <label>Percentage</label>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        {(variationDetails[variation.id]?.discount_type || "price") === "price" && (
                                                            <div className="form-group">
                                                                <label>Discount Price</label>
                                                                <input
                                                                    type="number"
                                                                    placeholder="Enter discount price"
                                                                    value={variationDetails[variation.id]?.discount_price || ""}
                                                                    onChange={(e) =>
                                                                        handleVariationDetailChange(
                                                                            variation.id,
                                                                            "discount_price",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                            </div>
                                                        )}

                                                        {variationDetails[variation.id]?.discount_type === "percentage" && (
                                                            <div className="form-group">
                                                                <label>Discount Percentage (%)</label>
                                                                <input
                                                                    type="number"
                                                                    placeholder="Enter discount percentage"
                                                                    value={variationDetails[variation.id]?.discount_percentage || ""}
                                                                    onChange={(e) =>
                                                                        handleVariationDetailChange(
                                                                            variation.id,
                                                                            "discount_percentage",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                            </div>
                                                        )}

                                                        <div className="form-group">
                                                            <label>Sale Price:</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Sale Price"
                                                                value={variationDetails[variation.id]?.salePrice || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'salePrice', e.target.value)}
                                                                onWheel={(e) => e.target.blur()}
                                                                readOnly
                                                                style={{ borderColor: variationErrors[variation.id] ? 'red' : undefined }}
                                                            />
                                                            {variationErrors[variation.id] && (
                                                                <div style={{ color: 'red', fontSize: '12px' }}>
                                                                    {variationErrors[variation.id]}
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="oms-form-group">
                                                            <label htmlFor="description" className="oms-form-label">
                                                                Description
                                                            </label>
                                                            <ReactQuill
                                                                theme="snow"
                                                                value={(variationDetails[variation.id]?.description || variation.description)}
                                                                onChange={(value) =>
                                                                    handleVariationDetailChange(variation.id, 'description', value)
                                                                }

                                                                style={{ backgroundColor: "#fefffc" }}
                                                                placeholder="Enter Description"
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label>SKU:</label>
                                                            <input
                                                                type="text"
                                                                placeholder="SKU"
                                                                value={(variationDetails[variation.id]?.sku || variation.sku)?.toUpperCase()}
                                                                onChange={(e) =>
                                                                    handleVariationDetailChange(variation.id, 'sku', e.target.value.toUpperCase())
                                                                }
                                                            />

                                                        </div>

                                                        <div className="form-group">
                                                            <label>Stock:</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Stock"
                                                                value={variationDetails[variation.id]?.stock || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'stock', e.target.value)}
                                                                onWheel={(e) => e.target.blur()}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Modals */}
                            <ImageModalEquip
                                show={showModalVar}
                                handleClose={handleCloseModalVar}
                                images={imagesVar} // ✅ use dedicated state
                                onImageSelect={(image) => handleVariationImageSelect(currentVariationId, image)}
                                multiple={false}
                                setImages={setImagesVar} // ✅ separate setter
                            />

                            <ImageModalGallery
                                show={showModalVar1}
                                handleClose={() => setShowModalVar1(false)}
                                images={imagesVar}
                                onImageSelect={(imgs) => handleVariationGallerySelect(currentVariationId, imgs)}
                                multiple={true}
                                setImages={setImagesVar}
                            />


                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Stock Status
                            </label>
                            <Select
                                options={StockOptions}
                                placeholder="Select Stock Status"
                                name="stock"
                                value={formData.stock}
                                onChange={handleSelectChange}
                            />
                        </div>


                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Key Features</label>
                            <div>
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Enter key feature"
                                    value={keyFeatureInput}
                                    onChange={(e) => setKeyFeatureInput(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (keyFeatureInput.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                key_features: [
                                                    ...prev.key_features,
                                                    {
                                                        id: crypto.randomUUID(),
                                                        text: keyFeatureInput.trim()
                                                    }
                                                ]
                                            }));
                                            setKeyFeatureInput('');
                                        }
                                    }}
                                    style={{ marginTop: "10px" }}
                                >
                                    Add More
                                </button>
                            </div>
                            <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={({ active, over }) => {
                                    if (!over) return;

                                    if (active.id !== over.id) {

                                        const oldIndex = formData.key_features.findIndex(
                                            item => item.id === active.id
                                        );

                                        const newIndex = formData.key_features.findIndex(
                                            item => item.id === over.id
                                        );

                                        const reordered = arrayMove(
                                            formData.key_features,
                                            oldIndex,
                                            newIndex
                                        );

                                        setFormData(prev => ({
                                            ...prev,
                                            key_features: reordered
                                        }));
                                    }
                                }}
                            >
                                <SortableContext
                                    items={(formData?.key_features || []).map(f => f.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ul className="oms-tag-list">
                                        {(formData?.key_features || []).map(feature => (
                                            <SortableKeyFeature
                                                key={feature.id}
                                                feature={feature}
                                                setFormData={setFormData}
                                            />
                                        ))}
                                    </ul>
                                </SortableContext>
                            </DndContext>
                        </div>

                        {/* Specifications Section */}
                        {/* Specifications */}
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Specifications</label>
                            <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Label"
                                    value={specInput.label}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, label: e.target.value }))}
                                />
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Value"
                                    value={specInput.value}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, value: e.target.value }))}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (specInput.label.trim() && specInput.value.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                specifications: [
                                                    ...prev.specifications,
                                                    { ...specInput, id: crypto.randomUUID() }
                                                ],
                                            }));
                                            setSpecInput({ label: '', value: '' });
                                        }
                                    }}
                                >
                                    Add More
                                </button>
                            </div>

                            <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={({ active, over }) => {
                                    if (!over) return;

                                    if (active.id !== over.id) {
                                        const oldIndex = formData.specifications.findIndex(
                                            item => item.id === active.id
                                        );

                                        const newIndex = formData.specifications.findIndex(
                                            item => item.id === over.id
                                        );

                                        const reordered = arrayMove(
                                            formData.specifications,
                                            oldIndex,
                                            newIndex
                                        );

                                        setFormData(prev => ({
                                            ...prev,
                                            specifications: reordered
                                        }));
                                    }
                                }}
                            >
                                <SortableContext
                                    items={(formData?.specifications || []).map(item => item.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ul className="oms-tag-list">
                                        {(formData?.specifications || []).map((spec, index) => (
                                            <SortableSpecification
                                                key={spec.id}
                                                spec={spec}
                                                index={index}
                                                setFormData={setFormData}
                                            />
                                        ))}
                                    </ul>
                                </SortableContext>
                            </DndContext>
                        </div>
                        {/* Category */}
                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Category
                            </label>
                            <Select
                                options={categories}
                                placeholder="Select category"
                                name="category"
                                value={formData.category}
                                onChange={handleSelectChange}
                                isClearable
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="brand_name" className="oms-form-label">
                                Brand
                            </label>
                            <Select
                                options={brand}
                                placeholder="Select brand"
                                name="brand_name"
                                value={formData.brand_name}
                                onChange={handleSelectChangeBrand}
                                isClearable
                            />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Yes"
                                        checked={formData.warranty.includes("Yes")}
                                        onChange={(e) => updateTypeofWar("Yes", e.target.checked)}
                                    />
                                    <label htmlFor="Yes">Yes</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="No"
                                        checked={formData.warranty.includes("No")}
                                        onChange={(e) => updateTypeofWar("No", e.target.checked)}
                                    />

                                    <label htmlFor="No">No</label>
                                </div>
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty From</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Us"
                                        checked={formData.warranty_from.includes("Us")}
                                        onChange={(e) => updateTypeofWarfrom("Us", e.target.checked)}
                                    />
                                    <label htmlFor="Us">Us</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Company"
                                        checked={formData.warranty_from.includes("Company")}
                                        onChange={(e) => updateTypeofWarfrom("Company", e.target.checked)}
                                    />

                                    <label htmlFor="Company">Company</label>
                                </div>
                            </div>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="warranty_note" className="oms-form-label">
                                Warranty note
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.warranty_note}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, warranty_note: value }))
                                }
                                placeholder="Enter Warranty Note"
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="delivery_days" className="oms-form-label">
                                Delivery Days
                            </label>
                            <input
                                type="number"
                                id="delivery_days"
                                placeholder="Enter Delivery within days"
                                value={formData.delivery_days}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Choose Home Category</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Best Sellers"
                                        checked={formData.categorytype?.includes("Best Sellers")}
                                        onChange={(e) => updateTypeofCat("Best Sellers", e.target.checked)}
                                    />
                                    <label htmlFor="Best Sellers">Best Sellers</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Trending"
                                        checked={formData.categorytype?.includes("Trending")}
                                        onChange={(e) => updateTypeofCat("Trending", e.target.checked)}
                                    />

                                    <label htmlFor="Trending">Trending</label>
                                </div>
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Installation</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Free Installation"
                                        checked={formData.installation?.includes("Free Installation")}
                                        onChange={(e) => updateTypeofInstall("Free Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Free Installation">Free Installation</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Paid Installation"
                                        checked={formData.installation?.includes("Paid Installation")}
                                        onChange={(e) => updateTypeofInstall("Paid Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Paid Installation">Paid Installation</label>
                                </div>
                            </div>
                        </div>

                        {
                            formData?.installation && (formData?.installation[0] === "Paid Installation" || formData.installation === "Paid Installation") &&
                            <div className="oms-form-group">
                                <label htmlFor="installation_fee" className="oms-form-label">
                                    Installation Fee
                                </label>
                                <input
                                    type="number"
                                    id="installation_fee"
                                    placeholder="Enter Installation Fee"
                                    value={formData.installation_fee}
                                    onChange={handleChange1}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        }

                        <div className="oms-form-group">
                            <label className="oms-form-label">GST Type</label>

                            <div className="oms-checkbox-group">
                                {/* Included GST */}
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="gst_included"
                                        name="gst_type"
                                        checked={formData.gst_type === "included"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                gst_type: "included",
                                                gst_percentage: "" // clear gst %
                                            }))
                                        }
                                    />
                                    <label htmlFor="gst_included">Included GST</label>
                                </div>

                                {/* Excluded GST */}
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="gst_excluded"
                                        name="gst_type"
                                        checked={formData.gst_type === "excluded"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                gst_type: "excluded"
                                            }))
                                        }
                                    />
                                    <label htmlFor="gst_excluded">Excluded GST</label>
                                </div>
                            </div>
                        </div>

                        {/* GST Percentage - show only when excluded */}
                        {formData.gst_type === "excluded" && (
                            <div className="oms-form-group">
                                <label className="oms-form-label">GST Percentage (%)</label>
                                <input
                                    type="number"
                                    placeholder="Enter GST percentage e.g. 18"
                                    value={formData.gst_percentage}
                                    onChange={(e) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            gst_percentage: e.target.value
                                        }))
                                    }
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        )}
                        <div className="oms-form-group">
                            <label htmlFor="hsn" className="oms-form-label">
                                HSN CODE
                            </label>
                            <input
                                type="text"
                                id="hsn"
                                placeholder="Enter HSN CODE"
                                value={formData.hsn}
                                onChange={handleChange1}
                            />
                        </div>
                        <ProductButtonOptions
                            formData={formData}
                            onChange={(field, value) =>
                                setFormData((prev) => ({ ...prev, [field]: value }))
                            }
                        />
                        {/* Status */}
                        <div className="oms-form-group">
                            <label htmlFor="status" className="oms-form-label">
                                Status
                            </label>
                            <Select
                                options={statusOptions}
                                placeholder="Select status"
                                name="status"
                                value={formData.status?.value ? formData.status : null}
                                onChange={handleSelectChange}
                            />
                        </div>

                        {/* Actions */}


                        <div className="oms-form-actions">
                            {
                                loading ? <button className='post-property-submit'>
                                    Updating...
                                </button> : <button className='post-property-submit' onClick={handleSubmit} >
                                    Update
                                </button>
                            }
                            {/* <button type="submit" className='post-property-submit'>Update</button> */}
                        </div>
                    </div>

                </form >
            </div >
        </>
    );
};

export default VariableProductEdit;


const DownloadableFiles = () => {
    const [files, setFiles] = useState([{ name: '', url: '', file: null }]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);

    const handleAddFile = () => {
        setFiles([...files, { name: '', url: '', file: null }]);
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
    };

    const handleChange = (index, field, value) => {
        const updatedFiles = [...files];
        updatedFiles[index][field] = value;
        setFiles(updatedFiles);
    };

    return (
        <div className="downloadable-section">
            {/* <h4>Downloadable files</h4> */}
            <div className="file-input-table">
                {files.map((file, index) => (
                    <div className="file-row" key={index}>
                        <input
                            type="text"
                            placeholder="File name"
                            value={file.name}
                            onChange={(e) => handleChange(index, 'name', e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="http://"
                            value={file.url}
                            onChange={(e) => handleChange(index, 'url', e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={() => setShowImageModal(true)}
                        >
                            Choose file
                        </button>
                        <input
                            id={`fileInput-${index}`}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => handleChange(index, 'file', e.target.files[0])}
                        />
                        <button
                            type="button"
                            className="remove-btn"
                            onClick={() => handleRemoveFile(index)}
                        >
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                        <ImageModalDownloadable
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            // onImageSelect={(img) =>
                            //     setFormData((prev) => ({ ...prev, image: [img] }))
                            // }
                            multiple={false}
                            setImages={setImages}
                        />
                    </div>
                ))}
                <button className="add-btn" type="button" onClick={handleAddFile}>
                    Add File
                </button>
            </div>
        </div>
    );
};

function SortableSpecification({ spec, index, setFormData }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: spec.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <li
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className="oms-tag-item"
        >
            <strong>{spec.label}:</strong> {spec.value}

            <X
                type="button"
                className="oms-tag-delete"
                onClick={() => {
                    setFormData(prev => ({
                        ...prev,
                        specifications: prev.specifications.filter(
                            s => s.id !== spec.id
                        )
                    }));
                }}
                size={14}
            />
        </li>
    );
}